import { getDisplayName, Spinner } from '@cp-shared-19/frontend-ui';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type withLoadingHandlerProps = {
    isLoading: boolean;
    loadingPlaceholder?: ReactElement;
};

// eslint-disable-next-line
export const withLoadingHandler = <TProps extends object>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withLoadingHandlerProps> => {
    const Wrapper: React.FC<TProps & withLoadingHandlerProps> = ({
        isLoading,
        loadingPlaceholder,
        ...props
    }: withLoadingHandlerProps) => {
        const { t } = useTranslation('loader');

        return isLoading ? (
            loadingPlaceholder || (
                <Spinner center={true}>
                    <p>{t('genericText')}</p>
                </Spinner>
            )
        ) : (
            <WrappedComponent {...(props as TProps)} />
        );
    };

    Wrapper.displayName = `withLoadingHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
